"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyContext = void 0;
exports.surveyReducer = surveyReducer;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const React = __importStar(require("react"));
function surveyReducer(state, action) {
    switch (action.type) {
        case 'setDevMode':
            console.log('Setting dev mode ', action.value);
            return { devMode: action.value };
    }
}
/**
 * This context contains the survey specific data, to build the questionnaire
 * widgets: widget configurations, sections, questions, etc.
 *
 * This data is fixed during the app initialization, is provided by the survey
 * application itself and does not change
 *
 * FIXME: Widgets and sections cannot change for the app. It can go in the
 * application.config instead of context. This way, it will be available even
 * outside react widgets.
 */
exports.SurveyContext = React.createContext({
    sections: {},
    widgets: {},
    devMode: false,
    dispatch: () => {
        /* To be replaced with actual dispatch */
    },
    appContext: undefined
});
//# sourceMappingURL=SurveyContext.js.map